import React, { Component } from 'react';
import PropTypes from 'prop-types';

import imgAPPP from 'images/concept-energy-label-appp.svg';
import imgAPP from 'images/concept-energy-label-app.svg';
import imgAP from 'images/concept-energy-label-ap.svg';
import imgA from 'images/concept-energy-label-a.svg';
import imgB from 'images/concept-energy-label-b.svg';
import imgC from 'images/concept-energy-label-c.svg';
import imgD from 'images/concept-energy-label-d.svg';
import imgE from 'images/concept-energy-label-e.svg';
import imgF from 'images/concept-energy-label-f.svg';
import imgG from 'images/concept-energy-label-g.svg';

import './efficiency.styles.scss';

export default class Efficiency extends Component {
    render() {
        const { value } = this.props;

        const showMetric = window.Checkout.settings.show_metric_product_measurements;
        const showImperial = window.Checkout.settings.show_imperial_product_measurements;

        if (!value) return null;

        const efficiencies = [];

        // Efficiency is usually a string
        if (typeof value === 'string') {
            efficiencies.push(this.efficiencyImage(value));
        }

        // …but sometimes it’s an object with metric and imperial keys
        if (showMetric) {
            efficiencies.push(this.efficiencyImage(value.metric, 'metric-' + value.metric));
        }
        if (showImperial) {
            efficiencies.push(this.efficiencyImage(value.imperial, 'imperial-' + value.imperial));
        }

        return <li className="product__description-product-efficiency">{ efficiencies }</li>;
    }

    efficiencyImage(value, key) {
        const images = { imgAPPP, imgAPP, imgAP, imgA, imgB, imgC, imgD, imgE, imgF, imgG };
        const src = 'img' + value.replace(/\+/g, 'P');
        return <img className="efficiency" key={key || value} alt={value} src={images[src]}/>;
    }
}

Efficiency.defaultProps = {
    value: null,
};

Efficiency.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            metric: PropTypes.string,
            imperial: PropTypes.string,
        }),
    ]),
};
